const Components = {
    common: {
        name: 'Nombre',
        description: 'Descripción',
        title: 'Título'
    },
    header: {
        profile: 'Perfil'
    },
    modal: {
        confirmDelete: '¿Seguro que deseas borrar este elemento?',
        createLand: 'Agregar nueva finca',
        editLand: 'Editar datos de la finca',
        createAnimal: 'Agregar nuevo animal',
        editAnimal: 'Editar datos del animal'
    },
    shareModal: {
        title: 'Compartir',
        publicProfileButton: 'Quiero hacer mi perfil público',
        privateProfileButton: 'Quiero hacer mi perfil privado',
        publicProfileInfo:
            'Si hace su perfil público, podrá compartir la información de sus fincas y sus animales.',
        publicProfileInfo2:
            'Los perfiles públicos permiten a otros clientes compartir sus fincas y sus animales con usted.',
        privateProfileInfo:
            'Si hace su perfil privado, no podrá compartir la información de sus fincas y sus animales. Las fincas y los animales que ya estén compartidos no cambiarán.',
        privateProfileInfo2:
            'Los perfiles privados no permiten a otros clientes compartir sus fincas y sus animales con usted.',
        currentReaders: 'Invitados actuales:',
        currentEditors: 'Colaboradores actuales:',
        addReaders: 'Añadir invitado:',
        addEditors: 'Añadir colaborador:',
        reader: 'Los invitados pueden ver la información de las fincas y de sus animales pero no pueden cambiarla ni borrarla.',
        editor: 'Los colaboradores pueden cambiar la información de las fincas, de sus animales y crear animales pero no pueden borrar información.',
        owner: 'Los propietario pueden ver, cambiar y borrar la información de las fincas y de sus animales.'
    },
    filters: {
        filters: 'Filtros',
        filter: 'Filtro',
        clear: 'Limpiar',
        apply: 'Aplicar',
        all: 'Todos',
        typeToSearch: 'Escriba para buscar',
        advanced: 'Filtro avanzado',
        chooseOne: 'Elija uno',
        filterById: 'Filtrar por indentificador',
        filterByLand: 'Filtrar por finca',
        filterBySpecie: 'Filtrar por especie',
        filterByGender: 'Filtrar por género',
        filterByType: 'Filtrar por tipo'
    },
    toast: {
        invalidAccess: 'No tiene permitido el acceso a este recurso.',
        userUpdated: 'Usuario actualizado correctamente.'
    },
    login: {
        title: 'Accede a tu cuenta',
        login: 'Entrar',
        logout: 'Cerrar sesión',
        privacy1: 'Al hacer clic en Entrar, aceptas nuestros',
        privacy2: ' Términos y Condiciones',
        resetPassword: 'Necesito restablecer mi contraseña',
        noAccount: '¿Aún no tienes cuenta?',
        createAccount: 'Crea una ahora'
    },
    register: {
        title: 'Crea tu cuenta',
        register: 'Registrarse',
        alreadyAccount: '¿Ya tienes cuenta?',
        loginAccount: 'Inicia sesión'
    },
    password: {
        title: 'Recupera tu contraseña',
        emailSent:
            'Se ha enviado un email, por favor revisa tu bandeja de entrada de correo electronico'
    },
    offline: {
        title: 'No es posible conectarse a internet en este momento.'
    },
    notVerified: {
        title: 'Bienvenido!',
        text: `Antes de acceder, todas las cuentas son verificadas por un administrador.
        Por favor, vuelve en 24 horas o contacta con el administrador en el correo mifinca2022app@gmail.com para que tu cuenta sea verificada.`
    },
    analysis: {
        title: 'Análisis'
    },
    users: {
        title: 'Usuarios'
    },
    profile: {
        profile: 'Perfil',
        name: 'Nombre',
        email: 'Correo electrónico',
        language: 'Idioma',
        settings: 'Ajustes',
        english: 'English',
        spanish: 'Español'
    },
    notFound: {
        title: 'Página no encontrada'
    },
    finance: {
        add: 'Añade un gasto o ingreso',
        finances: 'Finanzas',
        list: 'Listado',
        type: 'Tipo',
        subject: 'Tema',
        amount: 'Importe',
        category: 'Categoría',
        attachments: 'Adjuntos',
        addAttachment: 'Añadir adjunto',
        attachmentHelper:
            'Puedes añadir diferentes tipos de archivos para almacenar facturas, recibos, imágenes, etc...',
        size: 'Tamaño',
        types: {
            income: 'Ingreso',
            incomes: 'Ingresos',
            outcome: 'Gasto',
            outcomes: 'Gastos'
        },
        edit: {
            income: 'Editar la infomacion de este ingreso',
            outcome: 'Editar la infomacion de este gasto'
        },
        income: {
            sell: 'Venta',
            rent: 'Alquiler',
            subvention: 'Subvención',
            other: 'Otros',
            undefined: 'Sin clasificar'
        },
        outcome: {
            food: 'Alimentación',
            salary: 'Salarios',
            maintenance: 'Mantenimiento',
            veterinary: 'Veterinario',
            other: 'Otros',
            undefined: 'Sin clasificar'
        }
    },
    shell: {
        title: 'Datos económicos',
        noShell: 'Este animal no ha sido vendido ni sacrificado',
        edit: 'Añade una gestión',
        type: 'Tipo de gestión',
        buyer: 'Comprador',
        note: 'Nota',
        types: {
            shelled: 'Vendido',
            sacrifice: 'Sacrificado'
        }
    }
};

export default Components;
